import { render, staticRenderFns } from "./triangle.vue?vue&type=template&id=02590b2a&scoped=true"
import script from "./triangle.vue?vue&type=script&lang=js"
export * from "./triangle.vue?vue&type=script&lang=js"
import style0 from "./triangle.vue?vue&type=style&index=0&id=02590b2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02590b2a",
  null
  
)

export default component.exports